module.exports = __webpack_public_path__ + "static/media/g.45a1f61a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/g.mp3
// module id = 96
// module chunks = 0